export * from '@discoverer/fuse/components/loading-bar/loading-bar.component';
export * from '@discoverer/fuse/components/loading-bar/loading-bar.module';
